import React from "react";
import NavbarComponent from '../component/NavbarComponent'

const FeeStructure = () => {
  return (
    <React.Fragment>
   
 <NavbarComponent />
      <div className="">
        <div className="py-4 text-center bg-[#2d6386]">
          <span className="text-4xl text-white">Fee Structure</span>
        </div>
        <div className="lg:p-10  pl-3 pr-3 pb-3">
          <div className="relative w-full overflow-x-auto shadow-md sm:rounded-lg">
            <table className="min-w-full border text-center">
              <thead className="border-b ">
                <tr><td colSpan={2} > <div className="text-xl  w-full text-center text-white uppercase py-3 bg-red-600 font-semibold">
              Details of Admission fee
            </div></td></tr>
                <tr className="bg-gray-100">
                  <th className="py-3"> Classes</th>
                  <th className="py-3">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Pre-Nursery
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    Not Applicable as Admission starts from Class-1
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Nursery
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    NA
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    I-IV
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    Rs.270/- (Per Month Tuition Fees)
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    V-VIII
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    Rs.300/-(Per Month Tuition Fees)
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    IX & X
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    Rs.340/-(Per Month Tuition Fees)
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    XI & XII
                  </td>
                  <td className="text-sm text-gray-900 font-medium px-6 py-4 whitespace-nowrap border-r">
                    Rs.450/-(Per Month Tuition Fees)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex justify-center mt-2">
            <span className='font-bold text-xl'>NOTE : </span> 
            <span className="px-2 text-xl">
            No fee Charges for girl students
              </span>
        </div>
        </div>
      </div>
      <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
    </React.Fragment>
  );
};

export default FeeStructure;
